import useLocalizedTitle from '@/hooks/useLocalizedTitle';

function LocalizedTitle({ titleKey = 'LiisManagement', children }) {
  useLocalizedTitle(titleKey);

  return children;
}

export default LocalizedTitle;
